const dateFormat = "MM/DD/YYYY"
const dateFormatForBackend = "YYYY/MM/DD"
const errorTimeout = 3000

export { dateFormat, errorTimeout, dateFormatForBackend }
